import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { DeleteFilePurchaseOrder } from "@/common/services/purchaseOrder.api";
import { Modal } from "flowbite-react";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";

type Props = {
  file: string
  onClose: () => void
}

function ModalDeleteFile(props: Props) {

  const { purchaseOrderId } = useParams();
  const { notifyError } = useToastContext();

  const formik = useFormik({
    initialValues: { file: props.file, purchaseOrderId: purchaseOrderId as string },
    onSubmit: async (data) => {
      const result = await DeleteFilePurchaseOrder(data);
      if (!result.ok) {
        notifyError("Não autorizado. Compra já está aprovada");
        return;
      }
      window.location.reload();
    }
  })

  return (
    <Modal show={true} onClose={props.onClose}>
      <Modal.Header>
        <h2>{`Tem certeza que deseja deletar este arquivo: ${props.file} ?`}</h2>
      </Modal.Header>
      <Modal.Body>
        <ButtonWithLoader onClick={formik.handleSubmit}>Deletar</ButtonWithLoader>
      </Modal.Body>
    </Modal>
  )
}

export default ModalDeleteFile;